'use client';

import { logAnalyticsEvent } from "@/lib/analytics";
import { useEffect } from "react";

export function PwaHandler() {
    useEffect(() => {
        window.addEventListener("appinstalled", () => {
            logAnalyticsEvent('pwa_installed');
        });
    }, []);
    return null;
}